import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfigureBlockingModalComponent } from 'app/home/paraEmpresas/block/configure/content.component';
import { BlockGroupService } from 'app/services/block.group.service';
import { AlertService } from 'app/utils/alert.service';
import { BindComponentService } from "app/utils/bind.component.service";
import { DataPackGroup } from 'app/models/dataPackGroup.model';
import { DataPackLine } from 'app/models/dataPackLine.model';

import { LoadingComponent } from 'app/home/paraEmpresas/modalLoading/content.component';
import * as _ from "lodash";
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap/accordion/accordion";
/**
 * @version $Id: content.component.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
@Component({
    selector: 'dataBlockComponent',
    templateUrl: './content.template.html'
})
export class DataBlockComponent implements OnInit {
    @Input() private totalGroups: number;



    private static readonly GROUPS_FETCH_SIZE: number = 20;
    private static readonly LINES_FETCH_SIZE: number = 20;

    private static readonly FILTER_ALL_LINES = 'all_lines';
    private static readonly FILTER_BLOCKED_LINES = 'blocked_lines';
    private static readonly FILTER_UNBLOCKED_LINES = 'unblocked_lines';

    private groups: Array<DataPackGroup> = new Array<DataPackGroup>();
    public filter: string = DataBlockComponent.FILTER_ALL_LINES;
    private filterValue: string = '';
    private filteredGroups: Array<DataPackGroup> = new Array<DataPackGroup>();
    private selectedGroup: DataPackGroup;
    private selectedLines: Set<string> = new Set<string>();

    private groupsFetchSize: number = DataBlockComponent.GROUPS_FETCH_SIZE;
    private linesFetchSize: number = DataBlockComponent.LINES_FETCH_SIZE;
    private displayShowMoreGroupsButton: boolean = false;
    private displayShowMoreLinesButton: Map<number, boolean> = new Map<number, boolean>();

    private groupSortingCriteria: string;
    private groupSortingAsc: boolean = true;

    private lineSortingCriteria: string;
    private lineSortingAsc: boolean = true;
    private filtered: boolean = false;
    private pageGroup: number;
    private blockLines: boolean;
    private moreLines: boolean;

    @ViewChild('pageAccordion')
    pageAccordion: NgbAccordion;

    constructor(private modal: NgbModal, private blockGroupService: BlockGroupService, private alertService: AlertService, private bindComponent: BindComponentService) {

    }

    ngOnInit() {
        this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'BLOCK_DATA_4G_5G_FILTER'); //ALTERADO
        this.loadView();
        this.bindComponent.set(BindComponentService.IS_VOICE_CONSUMPTION, false);
    }

    ngAfterViewInit() {

        this.bindComponent.subscribe(BindComponentService.FILTER_BLOCK,
            group => {
                this.filteredGroups = new Array<DataPackGroup>();
                this.filteredGroups = group;
                this.setGroups(this.filteredGroups, false);
                this.selectedGroup = group;
                this.filtered = true;

            }
        );
    }

    public loadView() {
        this.openModalLoading();
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
        this.blockGroupService.loadView(1, DataBlockComponent.GROUPS_FETCH_SIZE, this.filter).subscribe(
            data => {
                this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
                let value: any = data;
                this.setGroups(value, false);
	                if (this.totalGroups > this.groups.length && this.groups.length > 0) {
                    this.displayShowMoreGroupsButton = true;
                }else{
                    this.displayShowMoreGroupsButton = false;
                }

                this.pageGroup = 1;
            },
            err => {
                this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
                this.alertService.error(err.result, err);
            }
        );

    }

    private setGroups(groups: Array<DataPackGroup>, append: boolean) {
        if (!append) {
            this.groups = groups;
        } else {
            Array.prototype.push.apply(this.groups, groups);
        }
        this.filteredGroups = this.groups;
        this.filterLines();
        this.clearSelections();
    }

    private setLines(group: DataPackGroup, lines: Array<DataPackLine>, append: boolean) {
        if (!append) {
            group.lines = lines;
        } else {
            Array.prototype.push.apply(group.lines, lines);
        }
        this.filterLines();
    }

    public filterLines(filter?: string) {
        this.clearFilterSelections();
        this.filter = filter || this.filter;
        if (this.moreLines) {
            this.filteredGroups = this.groups.filter(group => {
                let groupFiltered = false;
                this.selectedGroup.lines.forEach(line => {
                    groupFiltered = true;

                });
                return groupFiltered;
            });
        }
        else {
            this.filteredGroups = this.groups.filter(group => {
                let groupFiltered = false;
                group.lines.forEach(line => {
                    groupFiltered = true;
     
                });
                return groupFiltered;
            });
        }
    }
    public changePanel(filter?: string) {
        this.clearFilterSelections();
        this.filter = filter || this.filter;

        //console.log("O filtro escohlido foi o:" +this.filter);
        this.pageAccordion.activeIds = [];

        this.groups = new Array<DataPackGroup>();
        this.displayShowMoreLinesButton = new Map<number, boolean>();
        this.loadView();
        return true;
    }

    private searchText(text: string, value: string) {
        return text ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
    }

    private toggleGroup(group: DataPackGroup) {
        if (!this.selectedGroup || this.selectedGroup.id !== group.id) {
            this.selectedGroup = group;
        } else {
            this.selectedGroup = null;
        }
        this.lineSortingCriteria = null;
        this.lineSortingAsc = true;
        this.selectedLines.clear();
    }

    private sortGroups(field: string) {

        this.groupSortingAsc = this.groupSortingCriteria == field ? !this.groupSortingAsc : true;
        this.groupSortingCriteria = field;
        this.filteredGroups = _.orderBy(this.filteredGroups, [this.groupSortingCriteria], [this.groupSortingAsc ? 'asc' : 'desc']);
    }

    private sortLines(field: string) {
        this.lineSortingAsc = this.lineSortingCriteria == field ? !this.lineSortingAsc : true;
        this.lineSortingCriteria = field;
        this.selectedGroup.lines = _.orderBy(this.selectedGroup.lines, [this.lineSortingCriteria], [this.lineSortingAsc ? 'asc' : 'desc']);
    }
    private clearFilterSelections() {
        this.lineSortingCriteria = null;
        this.lineSortingAsc = true;
        this.groupSortingCriteria = null;
        this.groupSortingAsc = true;
        this.selectedLines.clear();

    }

    private clearSelections() {
        this.selectedGroup = null;
        this.clearFilterSelections();

    }

    private selectLine(line: DataPackLine) {
        if (!this.selectedLines.has(line.lineNumber)) {
            this.selectedLines.add(line.lineNumber);
            this.blockLines = line.blocked;
        } else {
            this.selectedLines.delete(line.lineNumber);
        }
    }

    private selectAllLines($event) {
        let checked = $event.srcElement.checked;
        if (checked) {
            this.selectedGroup.lines.forEach(line => {

                this.selectedLines.add(line.lineNumber);
                this.blockLines = line.blocked;
            });
        } else {
            this.selectedLines.clear();
        }
    }

    private showMoreGroups(): void {
        this.openModalLoading();
        this.pageGroup = this.pageGroup + 1;
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
        this.blockGroupService.loadView(this.groups.length + 1, this.groupsFetchSize).subscribe(
            data => {
                this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
                let value: any = data;
                this.setGroups(value, true);
                 if (this.groups.length >= this.totalGroups) {
                    this.displayShowMoreGroupsButton = false;
                 }else{
                     this.displayShowMoreGroupsButton = true;
                 }
            },
            err => {
                this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
                this.alertService.error(err.result, err);
            }
        );
    }

    private showMoreLines(): void {
        this.openModalLoading();
        this.blockGroupService.listLines(this.selectedGroup, this.selectedGroup.lines.length + 1, this.linesFetchSize, this.filter).subscribe(
            data => {
                let value: any = data;
                this.setLines(this.selectedGroup, value, true);
                this.moreLines = false
                if (value.length < this.linesFetchSize) {
                    this.displayShowMoreLinesButton[this.selectedGroup.id] = false;
                    this.moreLines = true
                }
                this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
            },
            err => {
                this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
                this.alertService.error(err.result, err);
            }
        );
    }

    private configureBlocking(line: DataPackLine) {
        if (this.selectedLines.size === 0) {
            this.alertService.warn('Selecione pelo menos uma linha');
            return;
        }
        let modalRef = this.modal.open(ConfigureBlockingModalComponent);
        modalRef.componentInstance.group = this.selectedGroup;
        modalRef.componentInstance.lines = this.selectedLines;
        modalRef.componentInstance.blockLines = this.blockLines;
        modalRef.result.then(result => this.loadView(), reason => null);
    }

    private maskMsisdn(msisdn: string): string {
        if (_.isNil(msisdn)) {
            return '';
        }
        if (msisdn.length == 12) {
            return '('.concat(msisdn.substr(0, 3)).concat(') ').concat(msisdn.substring(3, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
        } else if (msisdn.length == 11) {
            return '('.concat(msisdn.substr(0, 2)).concat(') ').concat(msisdn.substring(2, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
        }
        return msisdn;
    }

    private openModalLoading() {
        this.modal.open(LoadingComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modal-content-loading',
            size: 'lg',
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/data/content.component.ts